import { ARTICLE_NUMBER_PER_PAGE, apiUri } from '../appConfig';

const mediaList = (from = 0, count = ARTICLE_NUMBER_PER_PAGE) => (
	fetch(`${apiUri}/report?from=${from}&take=${count}`)
		.then((res) => res.json())
		.catch((err) => console.error(err))
);

export default mediaList;



// WEBPACK FOOTER //
// ./src/js/request/mediaList.js